import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/Layout';
import { initGA, logPageView, msalInstance } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import {
  BeforeYouStart,
  SelectDrainsIssue,
  CallUsPage,
  ThamesWaterPage,
  PrivatePropertyIssue,
  ReportToPrivateOwner,
  FloodAffecting,
  LocationAdditionalInformation,
  IssueLocation,
  ContactUserOption,
  EmailConfirmation,
  DescribeTheIssue,
  UploadPhoto,
  Confirmation,
  YourDetails,
} from './components/pages';
import { RoutesList, steps } from '../routes/Routes';
import { basename } from '../routes/basename';
import { useEffect } from 'react';
import { useScrollToTop } from '@shared/hooks';

function App() {
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);
  // It's important that the Router component is above the pages component because you'll need to use the useHistory hook before rendering MsalProvider
  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

function Pages() {
  useScrollToTop();

  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route path={'/'} element={<BeforeYouStart />} />
          <Route path={RoutesList.DRAINS_HOME} element={<BeforeYouStart />} />
          <Route path={RoutesList.ISSUE_TYPE} element={<SelectDrainsIssue />} />
          <Route
            path={RoutesList.DESCRIBE_ISSUE}
            element={<DescribeTheIssue />}
          />
          <Route path={RoutesList.CALL_US} element={<CallUsPage />} />
          <Route path={RoutesList.THAMES_WATER} element={<ThamesWaterPage />} />
          <Route
            path={RoutesList.PRIVATE_PROPERTY_ISSUE}
            element={<PrivatePropertyIssue />}
          />
          <Route path={RoutesList.ISSUE_LOCATION} element={<IssueLocation />} />
          <Route
            path={RoutesList.REPORT_TO_PRIVATE_PROPERTY_OWNER}
            element={<ReportToPrivateOwner />}
          />
          <Route
            path={RoutesList.FLOOD_AFFECTING}
            element={<FloodAffecting />}
          />
          <Route
            path={RoutesList.LOCATION_ADDITIONAL_INFORMATION}
            element={<LocationAdditionalInformation />}
          />

          <Route
            path={RoutesList.CONTACT_USER_OPTION}
            element={<ContactUserOption />}
          />
          <Route
            path={RoutesList.EMAIL_CONFIRMATION}
            element={<EmailConfirmation />}
          />
          <Route path={RoutesList.UPLOAD_PHOTOS} element={<UploadPhoto />} />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetails />} />
          <Route path={RoutesList.CONFIRMATION} element={<Confirmation />} />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}

export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};
export default App;
